import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';

export const fake_school_id = '111111111111111111111111';
export const STUDENT_ADMIN_ROLES = [
    'ROLE_TENANT_ADMIN',
    'ROLE_HEAD_TEACHER',
    'ROLE_ADMIN',
    'ROLE_SYSTEM',
    'ROLE_TECH_SUPPORT',
    'ROLE_STUDENT_ADMISSION',
];
export interface IMask {
    type: string;
    id: string;
    mask: any;
    sample: string;
    prefix: string;
}
export const phoneMaskConstants: Array<IMask> = [
    {
        type: 'Mask 1',
        id: 'mask1',
        prefix: '+1 ',
        mask: ['+', '1', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        sample: '+1 (555) 495-3456',
    },
    {
        type: 'Mask 2',
        id: 'mask2',
        prefix: '+7 ',
        mask: ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        sample: '+7 (555) 495-3456',
    },
    {
        type: 'Free Format',
        id: 'mask3',
        prefix: '',
        mask: /^[+]?\d*$/,
        sample: '+13242342342',
    },
];

export interface ValidationItem {
    type: string;
    message: string;
}

export interface ValidationType {
    [key: string]: ValidationItem[];
}

export interface LanguageItem {
    lang: string;
    name: string;
    variants: string[];
}

export const dataLanguages: LanguageItem[] = [
    {
        lang: 'af',
        name: 'Afrikaans',
        variants: [],
    },
    {
        lang: 'sq',
        name: 'Albanian',
        variants: [],
    },
    {
        lang: 'am',
        name: 'Amharic',
        variants: [],
    },
    {
        lang: 'ar',
        name: 'Arabic',
        variants: ['compat'],
    },
    {
        lang: 'hy',
        name: 'Armenian',
        variants: [],
    },
    {
        lang: 'as',
        name: 'Assamese',
        variants: [],
    },
    {
        lang: 'az',
        name: 'Azeri',
        variants: ['search'],
    },
    {
        lang: 'bn',
        name: 'Bengali',
        variants: [],
    },
    {
        lang: 'be',
        name: 'Belarusian',
        variants: [],
    },
    {
        lang: 'bs',
        name: 'Bosnian',
        variants: ['search'],
    },
    {
        lang: 'bs_Cyrl',
        name: 'Bosnian (Cyrillic)',
        variants: [],
    },
    {
        lang: 'bg',
        name: 'Bulgarian',
        variants: [],
    },
    {
        lang: 'my',
        name: 'Burmese',
        variants: [],
    },
    {
        lang: 'ca',
        name: 'Catalan',
        variants: ['search'],
    },
    {
        lang: 'chr',
        name: 'Cherokee',
        variants: [],
    },
    {
        lang: 'zh',
        name: 'Chinese',
        variants: ['big5han', 'gb2312han', 'unihan', 'zhuyin'],
    },
    {
        lang: 'zh_Hant',
        name: 'Chinese (Traditional)',
        variants: [],
    },
    {
        lang: 'hr',
        name: 'Croatian',
        variants: ['search'],
    },
    {
        lang: 'cs',
        name: 'Czech',
        variants: ['search'],
    },
    {
        lang: 'da',
        name: 'Danish',
        variants: ['search'],
    },
    {
        lang: 'nl',
        name: 'Dutch',
        variants: [],
    },
    {
        lang: 'dz',
        name: 'Dzongkha',
        variants: [],
    },
    {
        lang: 'en',
        name: 'English',
        variants: [],
    },
    {
        lang: 'en_US',
        name: 'English (United States)',
        variants: [],
    },
    {
        lang: 'en_US_POSIX',
        name: 'English (United States, Computer)',
        variants: [],
    },
    {
        lang: 'eo',
        name: 'Esperanto',
        variants: [],
    },
    {
        lang: 'et',
        name: 'Estonian',
        variants: [],
    },
    {
        lang: 'ee',
        name: 'Ewe',
        variants: [],
    },
    {
        lang: 'fo',
        name: 'Faroese',
        variants: [],
    },
    {
        lang: 'fil',
        name: 'Filipino',
        variants: [],
    },
    {
        lang: 'fi',
        name: 'Finnish',
        variants: ['search', 'traditional'],
    },
    {
        lang: 'fr_CA',
        name: 'French (Canada)',
        variants: [],
    },
    {
        lang: 'gl',
        name: 'Galician',
        variants: ['search'],
    },
    {
        lang: 'ka',
        name: 'Georgian',
        variants: [],
    },
    {
        lang: 'de',
        name: 'German',
        variants: ['search', 'eor', 'phonebook'],
    },
    {
        lang: 'de_AT',
        name: 'German (Austria)',
        variants: ['phonebook'],
    },
    {
        lang: 'el',
        name: 'Greek',
        variants: [],
    },
    {
        lang: 'gu',
        name: 'Gujarati',
        variants: [],
    },
    {
        lang: 'ha',
        name: 'Hausa',
        variants: [],
    },
    {
        lang: 'haw',
        name: 'Hawaiian',
        variants: [],
    },
    {
        lang: 'he',
        name: 'Hebrew',
        variants: ['search'],
    },
    {
        lang: 'hi',
        name: 'Hindi',
        variants: [],
    },
    {
        lang: 'hu',
        name: 'Hungarian',
        variants: [],
    },
    {
        lang: 'is',
        name: 'Icelandic',
        variants: ['search'],
    },
    {
        lang: 'ig',
        name: 'Igbo',
        variants: [],
    },
    {
        lang: 'smn',
        name: 'Inari Sami',
        variants: ['search'],
    },
    {
        lang: 'id',
        name: 'Indonesian',
        variants: [],
    },
    {
        lang: 'ga',
        name: 'Irish',
        variants: [],
    },
    {
        lang: 'it',
        name: 'Italian',
        variants: [],
    },
    {
        lang: 'ja',
        name: 'Japanese',
        variants: ['unihan'],
    },
    {
        lang: 'kl',
        name: 'Kalaallisut',
        variants: ['search'],
    },
    {
        lang: 'kn',
        name: 'Kannada',
        variants: ['traditional'],
    },
    {
        lang: 'kk',
        name: 'Kazakh',
        variants: [],
    },
    {
        lang: 'km',
        name: 'Khmer',
        variants: [],
    },
    {
        lang: 'kok',
        name: 'Konkani',
        variants: [],
    },
    {
        lang: 'ko',
        name: 'Korean',
        variants: ['search', 'searchjl', 'unihan'],
    },
    {
        lang: 'ky',
        name: 'Kyrgyz',
        variants: [],
    },
    {
        lang: 'lkt',
        name: 'Lakota',
        variants: [],
    },
    {
        lang: 'lo',
        name: 'Lao',
        variants: [],
    },
    {
        lang: 'lv',
        name: 'Latvian',
        variants: [],
    },
    {
        lang: 'ln',
        name: 'Lingala',
        variants: ['phonetic'],
    },
    {
        lang: 'lt',
        name: 'Lithuanian',
        variants: [],
    },
    {
        lang: 'dsb',
        name: 'Lower Sorbian',
        variants: [],
    },
    {
        lang: 'lb',
        name: 'Luxembourgish',
        variants: [],
    },
    {
        lang: 'mk',
        name: 'Macedonian',
        variants: [],
    },
    {
        lang: 'ms',
        name: 'Malay',
        variants: [],
    },
    {
        lang: 'ml',
        name: 'Malayalam',
        variants: [],
    },
    {
        lang: 'mt',
        name: 'Maltese',
        variants: [],
    },
    {
        lang: 'mr',
        name: 'Marathi',
        variants: [],
    },
    {
        lang: 'mn',
        name: 'Mongolian',
        variants: [],
    },
    {
        lang: 'ne',
        name: 'Nepali',
        variants: [],
    },
    {
        lang: 'se',
        name: 'Northern Sami',
        variants: ['search'],
    },
    {
        lang: 'nb',
        name: 'Norwegian Bokmål',
        variants: ['search'],
    },
    {
        lang: 'nn',
        name: 'Norwegian Nynorsk',
        variants: ['search'],
    },
    {
        lang: 'or',
        name: 'Oriya',
        variants: [],
    },
    {
        lang: 'om',
        name: 'Oromo',
        variants: [],
    },
    {
        lang: 'ps',
        name: 'Pashto',
        variants: [],
    },
    {
        lang: 'fa',
        name: 'Persian',
        variants: [],
    },
    {
        lang: 'fa_AF',
        name: 'Persian (Afghanistan)',
        variants: [],
    },
    {
        lang: 'pl',
        name: 'Polish',
        variants: [],
    },
    {
        lang: 'pt',
        name: 'Portuguese',
        variants: [],
    },
    {
        lang: 'pa',
        name: 'Punjabi',
        variants: [],
    },
    {
        lang: 'ro',
        name: 'Romanian',
        variants: [],
    },
    {
        lang: 'ru',
        name: 'Russian',
        variants: [],
    },
    {
        lang: 'sr',
        name: 'Serbian',
        variants: [],
    },
    {
        lang: 'sr_Latn',
        name: 'Serbian (Latin)',
        variants: ['search'],
    },
    {
        lang: 'si',
        name: 'Sinhala',
        variants: ['dictionary'],
    },
    {
        lang: 'sk',
        name: 'Slovak',
        variants: ['search'],
    },
    {
        lang: 'sl',
        name: 'Slovenian',
        variants: [],
    },
    {
        lang: 'es',
        name: 'Spanish',
        variants: ['search', 'traditional'],
    },
    {
        lang: 'sw',
        name: 'Swahili',
        variants: [],
    },
    {
        lang: 'sv',
        name: 'Swedish',
        variants: ['search'],
    },
    {
        lang: 'ta',
        name: 'Tamil',
        variants: [],
    },
    {
        lang: 'te',
        name: 'Telugu',
        variants: [],
    },
    {
        lang: 'th',
        name: 'Thai',
        variants: [],
    },
    {
        lang: 'bo',
        name: 'Tibetan',
        variants: [],
    },
    {
        lang: 'to',
        name: 'Tongan',
        variants: [],
    },
    {
        lang: 'tr',
        name: 'Turkish',
        variants: ['search'],
    },
    {
        lang: 'uk',
        name: 'Ukrainian',
        variants: [],
    },
    {
        lang: 'hsb',
        name: 'Upper Sorbian',
        variants: [],
    },
    {
        lang: 'ur',
        name: 'Urdu',
        variants: [],
    },
    {
        lang: 'ug',
        name: 'Uyghur',
        variants: [],
    },
    {
        lang: 'vi',
        name: 'Vietnamese',
        variants: ['traditional'],
    },
    {
        lang: 'wae',
        name: 'Walser',
        variants: [],
    },
    {
        lang: 'cy',
        name: 'Welsh',
        variants: [],
    },
    {
        lang: 'yi',
        name: 'Yiddish',
        variants: ['search'],
    },
    {
        lang: 'yo',
        name: 'Yoruba',
        variants: [],
    },
    {
        lang: 'zu',
        name: 'Zulu',
        variants: [],
    },
];
// eslint-disable-next-line func-style
export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
    return () => overlay.scrollStrategies.close();
}
